import React, { useState, useEffect } from 'react';

export default function ConditionModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    matchType: 'all', // 'all' or 'any'
    systemConditions: [
      {
        variable: 'First Name',
        operator: '=',
        value: ''
      }
    ],
    customConditions: [
      {
        variable: 'Select',
        operator: '=',
        value: ''
      }
    ]
  });

  useEffect(() => {
    if (open && node) {
      setFormData({
        matchType: node.data.matchType || 'all',
        systemConditions: node.data.systemConditions || [
          {
            variable: 'First Name',
            operator: '=',
            value: ''
          }
        ],
        customConditions: node.data.customConditions || [
          {
            variable: 'Select',
            operator: '=',
            value: ''
          }
        ]
      });
    }
  }, [open, node]);

  const handleSave = () => {
    if (onSave) {
      onSave(node.id, formData);
    }
    onClose();
  };

  const addSystemCondition = () => {
    setFormData(prev => ({
      ...prev,
      systemConditions: [
        ...prev.systemConditions,
        {
          variable: 'First Name',
          operator: '=',
          value: ''
        }
      ]
    }));
  };

  const addCustomCondition = () => {
    setFormData(prev => ({
      ...prev,
      customConditions: [
        ...prev.customConditions,
        {
          variable: 'Select',
          operator: '=',
          value: ''
        }
      ]
    }));
  };

  const updateSystemCondition = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      systemConditions: prev.systemConditions.map((condition, i) => 
        i === index ? { ...condition, [field]: value } : condition
      )
    }));
  };

  const updateCustomCondition = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      customConditions: prev.customConditions.map((condition, i) => 
        i === index ? { ...condition, [field]: value } : condition
      )
    }));
  };

  const removeSystemCondition = (index) => {
    if (formData.systemConditions.length > 1) {
      setFormData(prev => ({
        ...prev,
        systemConditions: prev.systemConditions.filter((_, i) => i !== index)
      }));
    }
  };

  const removeCustomCondition = (index) => {
    if (formData.customConditions.length > 1) {
      setFormData(prev => ({
        ...prev,
        customConditions: prev.customConditions.filter((_, i) => i !== index)
      }));
    }
  };

  if (!open) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const contentStyle = {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '600px',
    maxWidth: '700px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '24px'
  };

  const inputStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '8px 12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none'
  };

  const selectStyle = {
    ...inputStyle,
    backgroundColor: '#ffffff'
  };

  const buttonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px'
  };

  const secondaryButtonStyle = {
    background: '#6c757d',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px'
  };

  const toggleContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '24px',
    justifyContent: 'center'
  };

  const toggleOptionStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer'
  };

  const toggleSwitchStyle = {
    width: '40px',
    height: '20px',
    borderRadius: '10px',
    position: 'relative',
    cursor: 'pointer',
    transition: 'background-color 0.3s'
  };

  const toggleActiveStyle = {
    ...toggleSwitchStyle,
    backgroundColor: '#007bff'
  };

  const toggleInactiveStyle = {
    ...toggleSwitchStyle,
    backgroundColor: '#6c757d'
  };

  const toggleKnobStyle = {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    position: 'absolute',
    top: '2px',
    transition: 'transform 0.3s'
  };

  const toggleKnobActiveStyle = {
    ...toggleKnobStyle,
    transform: 'translateX(20px)'
  };

  const toggleKnobInactiveStyle = {
    ...toggleKnobStyle,
    transform: 'translateX(2px)'
  };

  const sectionStyle = {
    marginBottom: '24px'
  };

  const sectionHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px'
  };

  const sectionTitleStyle = {
    fontWeight: '600',
    color: '#495057',
    fontSize: '16px'
  };

  const addButtonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '14px'
  };

  const conditionRowStyle = {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 2fr auto',
    gap: '12px',
    alignItems: 'end',
    marginBottom: '12px'
  };

  const removeButtonStyle = {
    background: '#dc3545',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 10px',
    cursor: 'pointer',
    fontSize: '12px'
  };

  const dividerStyle = {
    border: 'none',
    borderTop: '2px dashed #d1d5db',
    margin: '24px 0'
  };

  const systemVariables = [
    'First Name',
    'Last Name',
    'Email',
    'Phone Number',
    'Language',
    'Country',
    'Timezone',
    'Created Date',
    'Last Activity'
  ];

  const operators = [
    '=',
    '!=',
    '>',
    '<',
    '>=',
    '<=',
    'contains',
    'starts with',
    'ends with',
    'is empty',
    'is not empty'
  ];

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={contentStyle} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={headerStyle}>
          <h2 style={{ margin: 0, color: '#495057', fontSize: '20px', fontWeight: '600' }}>
            Configure Condition
          </h2>
        </div>

        {/* Match Type Toggle */}
        <div style={toggleContainerStyle}>
          <div 
            style={toggleOptionStyle}
            onClick={() => setFormData(prev => ({ ...prev, matchType: 'all' }))}
          >
            <div style={formData.matchType === 'all' ? toggleActiveStyle : toggleInactiveStyle}>
              <div style={formData.matchType === 'all' ? toggleKnobActiveStyle : toggleKnobInactiveStyle}></div>
            </div>
            <span style={{ fontWeight: formData.matchType === 'all' ? '600' : '400' }}>All Match</span>
          </div>
          
          <div 
            style={toggleOptionStyle}
            onClick={() => setFormData(prev => ({ ...prev, matchType: 'any' }))}
          >
            <div style={formData.matchType === 'any' ? toggleActiveStyle : toggleInactiveStyle}>
              <div style={formData.matchType === 'any' ? toggleKnobActiveStyle : toggleKnobInactiveStyle}></div>
            </div>
            <span style={{ fontWeight: formData.matchType === 'any' ? '600' : '400' }}>Any Match</span>
          </div>
        </div>

        {/* System Field Section */}
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>
            <span style={sectionTitleStyle}>System Field</span>
            <button onClick={addSystemCondition} style={addButtonStyle}>
              +
            </button>
          </div>
          
          {formData.systemConditions.map((condition, index) => (
            <div key={index} style={conditionRowStyle}>
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', color: '#6c757d' }}>
                  Variable
                </label>
                <select
                  value={condition.variable}
                  onChange={e => updateSystemCondition(index, 'variable', e.target.value)}
                  style={selectStyle}
                >
                  {systemVariables.map(variable => (
                    <option key={variable} value={variable}>{variable}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', color: '#6c757d' }}>
                  Operator
                </label>
                <select
                  value={condition.operator}
                  onChange={e => updateSystemCondition(index, 'operator', e.target.value)}
                  style={selectStyle}
                >
                  {operators.map(operator => (
                    <option key={operator} value={operator}>{operator}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', color: '#6c757d' }}>
                  Value
                </label>
                <input
                  type="text"
                  value={condition.value}
                  onChange={e => updateSystemCondition(index, 'value', e.target.value)}
                  placeholder="Enter value..."
                  style={inputStyle}
                />
              </div>
              
              {formData.systemConditions.length > 1 && (
                <button 
                  onClick={() => removeSystemCondition(index)}
                  style={removeButtonStyle}
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Custom Field Section */}
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>
            <span style={sectionTitleStyle}>Custom Field</span>
            <button onClick={addCustomCondition} style={addButtonStyle}>
              +
            </button>
          </div>
          
          {formData.customConditions.map((condition, index) => (
            <div key={index} style={conditionRowStyle}>
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', color: '#6c757d' }}>
                  Variable
                </label>
                <select
                  value={condition.variable}
                  onChange={e => updateCustomCondition(index, 'variable', e.target.value)}
                  style={selectStyle}
                >
                  <option value="Select">Select</option>
                  <option value="Custom Field 1">Custom Field 1</option>
                  <option value="Custom Field 2">Custom Field 2</option>
                  <option value="Custom Field 3">Custom Field 3</option>
                </select>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', color: '#6c757d' }}>
                  Operator
                </label>
                <select
                  value={condition.operator}
                  onChange={e => updateCustomCondition(index, 'operator', e.target.value)}
                  style={selectStyle}
                >
                  {operators.map(operator => (
                    <option key={operator} value={operator}>{operator}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', color: '#6c757d' }}>
                  Value
                </label>
                <input
                  type="text"
                  value={condition.value}
                  onChange={e => updateCustomCondition(index, 'value', e.target.value)}
                  placeholder="Enter value..."
                  style={inputStyle}
                />
              </div>
              
              {formData.customConditions.length > 1 && (
                <button 
                  onClick={() => removeCustomCondition(index)}
                  style={removeButtonStyle}
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Divider */}
        <hr style={dividerStyle} />

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button onClick={handleSave} style={buttonStyle}>
            💾 Save
          </button>
          <button onClick={onClose} style={secondaryButtonStyle}>
            ✕ Close
          </button>
        </div>
      </div>
    </div>
  );
} 